import { render, staticRenderFns } from "./mo_allbuildings.vue?vue&type=template&id=85ce2c10&scoped=true"
import script from "./mo_allbuildings.vue?vue&type=script&lang=js"
export * from "./mo_allbuildings.vue?vue&type=script&lang=js"
import style0 from "./mo_allbuildings.vue?vue&type=style&index=0&id=85ce2c10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ce2c10",
  null
  
)

export default component.exports